<template>
  <div class="outages-list-search">
    <div
    class="search-container"
    v-bind:class="{darkMode: isDarkMode}">
      <input
      type="text"
      v-model="search.text"
      :placeholder="searchPlaceholder"
      v-debounce:800ms="handleSearchChange">
      <img class="search-icon" src="../../../assets/img/drawer-icon-search.svg" alt="search-icon">
    </div>
  </div>
</template>

<script>
export default {
  name: 'OutagesListSearch',
  props: {
      isDarkMode: Boolean,
      selectedTab: String,
      searchFilter: String,
      searchChange: Function
  },
  created() {this.getSearchPlaceholder()},
  watch: {
    selectedTab: function () {
      this.getSearchPlaceholder();
      this.search.text = undefined;
    }
  },
  data() {
    return {
      search: {},
      throttleTimeout: null,
      searchPlaceholder: ''
    };
  },
  methods: {
    handleSearchChange() {this.searchChange(this.search.text)},
    getSearchPlaceholder() {
      switch(this.selectedTab) {
        case 'town':
          this.searchPlaceholder = 'Search Towns';
          break;
        case 'county':
          this.searchPlaceholder = 'Search Counties';
          break;
        case 'utility':
          this.searchPlaceholder = 'Search Utilities';
          break;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

.outages-list-search{
  .search-container{
    position: relative;
    margin: 20px auto 0;
    padding-top: 20px;
    text-align: center;
    border-top: 4px solid $greyText;
    width: 90%;

    &.darkMode{
      border-top: 4px solid $orange
    }

    input[type="text"]{
      width: 100%;
      padding: 5px 5px 5px 10px;
      background-color: $whiteBackgroundTrans15;
      border-radius: 10px;
      border: none;
      font-size: 12px;
      color: $greyTextTrans65;

      &::placeholder {
        font-weight: 100;
        font-size: 12px;
        color: $greyTextTrans65;
      }
    }

    .search-icon{
      position: absolute;
      top: 25px;
      right: 15px;
      transform: scaleX(-1);
      width: 14px;
    }
  }
}
</style>
